// HKDSE 十二篇範文學習卡片數據
export const hkdseFlashCards = [
  // A1. 孟子《魚我所欲也》
  {
    id: 'hkdse-flashcards-a1-mengzi-fish',
    textId: 'hkdse-a1-mengzi-fish',
    title: '孟子《魚我所欲也》- 學習卡片',
    category: '議論散文',
    description: '重點概念和論證手法',
    totalCards: 20,
    cards: [
      {
        id: 1,
        front: '孟子《魚我所欲也》的中心論點是什麼？',
        back: '道義比生存更重要，人應該有捨生取義的精神。',
        category: '主旨理解',
        difficulty: 'intermediate'
      },
      {
        id: 2,
        front: '文中的「魚」和「熊掌」分別比喻什麼？',
        back: '「魚」比喻生存，「熊掌」比喻道義。',
        category: '比喻論證',
        difficulty: 'beginner'
      },
      {
        id: 3,
        front: '什麼是「本心」？',
        back: '本心是指人天生具有的善良道德本性，是捨生取義的內在動力。',
        category: '重要概念',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '孟子認為人失去本心的原因是什麼？',
        back: '受到物質利益的誘惑，被外在的慾望所蒙蔽。',
        category: '思想內容',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '「非禮勿視，非禮勿聽，非禮勿言，非禮勿動」運用了什麼修辭手法？',
        back: '排比修辭手法，四個「非禮勿」的句式整齊，語氣強烈。',
        category: '修辭手法',
        difficulty: 'beginner'
      },
      {
        id: 6,
        front: '文中運用了哪些論證方法？',
        back: '主要運用比喻論證和對比論證。',
        category: '論證手法',
        difficulty: 'intermediate'
      },
      {
        id: 7,
        front: '孟子的「義利之辨」是什麼意思？',
        back: '即對道義和利益的區分，強調道義重於利益。',
        category: '哲學思想',
        difficulty: 'advanced'
      },
      {
        id: 8,
        front: '賢者與一般人的區別是什麼？',
        back: '賢者能夠保持本心不失，而一般人容易失去本心。',
        category: '人物對比',
        difficulty: 'intermediate'
      },
      {
        id: 9,
        front: '文中的設問修辭有什麼作用？',
        back: '引起讀者思考，使論證更加深入人心。',
        category: '修辭作用',
        difficulty: 'intermediate'
      },
      {
        id: 10,
        front: '孟子寫作此文的目的是什麼？',
        back: '勸勉人們明辨義利，保持善良的本心，發揚義的善端。',
        category: '寫作目的',
        difficulty: 'intermediate'
      },
      {
        id: 11,
        front: '「捨生取義」的現實意義是什麼？',
        back: '在面臨道德選擇時，要堅持正義，不為利益所動。',
        category: '現實意義',
        difficulty: 'advanced'
      },
      {
        id: 12,
        front: '文中的正反立論體現在哪裡？',
        back: '正面論證道義的重要性，反面論證失去本心的危害。',
        category: '議論文手法',
        difficulty: 'advanced'
      },
      {
        id: 13,
        front: '孟子的人性觀是什麼？',
        back: '人性本善，每個人都有善良的本心。',
        category: '哲學觀點',
        difficulty: 'advanced'
      },
      {
        id: 14,
        front: '文中的比喻論證有什麼特點？',
        back: '以日常生活中的具體事物比喻抽象的道理，生動易懂。',
        category: '論證特點',
        difficulty: 'intermediate'
      },
      {
        id: 15,
        front: '「所欲有甚於生者」指的是什麼？',
        back: '指道義，比生命更重要的東西。',
        category: '重要語句',
        difficulty: 'intermediate'
      },
      {
        id: 16,
        front: '孟子論證的邏輯順序是什麼？',
        back: '提出論點→比喻論證→分析原因→勸勉結論。',
        category: '論證結構',
        difficulty: 'advanced'
      },
      {
        id: 17,
        front: '文中體現了什麼樣的價值觀？',
        back: '精神品格重於物質利益的價值觀。',
        category: '價值觀念',
        difficulty: 'intermediate'
      },
      {
        id: 18,
        front: '孟子的論證風格有什麼特點？',
        back: '生動形象，深入淺出，富有說服力。',
        category: '寫作風格',
        difficulty: 'intermediate'
      },
      {
        id: 19,
        front: '文中的對比論證體現在哪裡？',
        back: '生與義的對比，賢者與一般人的對比。',
        category: '對比手法',
        difficulty: 'intermediate'
      },
      {
        id: 20,
        front: '這篇文章對後世的影響是什麼？',
        back: '成為中華民族精神品格的重要組成部分，影響了中國人的價值觀。',
        category: '歷史影響',
        difficulty: 'advanced'
      }
    ]
  },

  // A2. 荀子《勸學》
  {
    id: 'hkdse-flashcards-a2-xunzi-learning',
    textId: 'hkdse-a2-xunzi-learning',
    title: '荀子《勸學》- 學習卡片',
    category: '議論散文',
    description: '學習理論和比喻論證',
    totalCards: 18,
    cards: [
      {
        id: 1,
        front: '荀子《勸學》的中心論點是什麼？',
        back: '學不可以已（學習不可以停止）。',
        category: '中心論點',
        difficulty: 'beginner'
      },
      {
        id: 2,
        front: '「青，取之於藍，而青於藍」說明了什麼道理？',
        back: '學習能夠改變人的本質，通過學習可以超越原有的水平。',
        category: '比喻論證',
        difficulty: 'intermediate'
      },
      {
        id: 3,
        front: '荀子認為學習的根本作用是什麼？',
        back: '改變人的本質，提升人的品格和能力。',
        category: '學習作用',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '「積土成山，風雨興焉」運用了什麼論證方法？',
        back: '比喻論證，說明學習需要不斷積累的道理。',
        category: '論證方法',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '荀子強調的學習態度是什麼？',
        back: '專心致志，持之以恆，不斷積累。',
        category: '學習態度',
        difficulty: 'intermediate'
      },
      {
        id: 6,
        front: '文中運用了哪些修辭手法？',
        back: '比喻、排比、對偶、對比、借代。',
        category: '修辭手法',
        difficulty: 'intermediate'
      },
      {
        id: 7,
        front: '「冰，水為之，而寒於水」說明了什麼？',
        back: '說明學習能夠使人超越原有的基礎，達到更高的境界。',
        category: '比喻含義',
        difficulty: 'intermediate'
      },
      {
        id: 8,
        front: '荀子的學習觀體現了什麼哲學思想？',
        back: '後天努力論，強調後天學習的重要性。',
        category: '哲學思想',
        difficulty: 'advanced'
      },
      {
        id: 9,
        front: '文中的層層遞進體現在哪裡？',
        back: '從學習的意義→作用→態度→方法，逐步深入。',
        category: '論證結構',
        difficulty: 'advanced'
      },
      {
        id: 10,
        front: '「君子博學而日參省乎己」的意思是什麼？',
        back: '君子要廣泛學習，每天反省自己。',
        category: '重要語句',
        difficulty: 'intermediate'
      },
      {
        id: 11,
        front: '荀子認為不學習的後果是什麼？',
        back: '一事無成，無法提升自己。',
        category: '反面論證',
        difficulty: 'intermediate'
      },
      {
        id: 12,
        front: '文中的對比論證體現在哪裡？',
        back: '學與不學的對比，專心與不專心的對比。',
        category: '對比手法',
        difficulty: 'intermediate'
      },
      {
        id: 13,
        front: '「積善成德，而神明自得」說明了什麼？',
        back: '說明學習和修養的積累能夠達到很高的境界。',
        category: '學習境界',
        difficulty: 'advanced'
      },
      {
        id: 14,
        front: '荀子的論證特點是什麼？',
        back: '善用比喻，生動形象，層層遞進。',
        category: '論證特點',
        difficulty: 'intermediate'
      },
      {
        id: 15,
        front: '文中的「借代」修辭體現在哪裡？',
        back: '用具體的事物代替抽象的道理。',
        category: '修辭分析',
        difficulty: 'advanced'
      },
      {
        id: 16,
        front: '荀子寫作此文的目的是什麼？',
        back: '勸勉人們要堅持學習，不可懈怠。',
        category: '寫作目的',
        difficulty: 'intermediate'
      },
      {
        id: 17,
        front: '《勸學》對現代教育的啟示是什麼？',
        back: '終身學習的重要性，學習需要持之以恆。',
        category: '現代意義',
        difficulty: 'advanced'
      },
      {
        id: 18,
        front: '文中體現了什麼樣的學習方法？',
        back: '博學、審問、慎思、明辨、篤行。',
        category: '學習方法',
        difficulty: 'advanced'
      }
    ]
  },

  // B1. 論語論仁
  {
    id: 'hkdse-flashcards-b1-analects-ren',
    textId: 'hkdse-b1-analects-ren',
    title: '《論語》論仁 - 學習卡片',
    category: '語錄體',
    description: '儒家仁學思想核心',
    totalCards: 15,
    cards: [
      {
        id: 1,
        front: '孔子的「仁」的核心內容是什麼？',
        back: '愛人、克己復禮、忠恕之道。',
        category: '核心概念',
        difficulty: 'intermediate'
      },
      {
        id: 2,
        front: '「克己復禮」的含義是什麼？',
        back: '克制自己的私慾，使行為符合禮法的要求。',
        category: '重要概念',
        difficulty: 'intermediate'
      },
      {
        id: 3,
        front: '「非禮勿視，非禮勿聽，非禮勿言，非禮勿動」體現了什麼？',
        back: '體現了仁的具體要求和自我修養的方法。',
        category: '實踐要求',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '仁者的態度特點是什麼？',
        back: '安於實行仁德，不會因外界影響而違背仁德。',
        category: '品格特徵',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '「仁者不憂」的原因是什麼？',
        back: '因為仁者品格高尚，內心平靜，不為外物所困擾。',
        category: '心境特點',
        difficulty: 'intermediate'
      },
      {
        id: 6,
        front: '語錄體的特點是什麼？',
        back: '簡潔精煉，用簡短的語言表達深刻的思想。',
        category: '文體特色',
        difficulty: 'beginner'
      },
      {
        id: 7,
        front: '《論語》中排比修辭的作用是什麼？',
        back: '增強語言氣勢，使內容更加全面，便於記憶。',
        category: '修辭作用',
        difficulty: 'intermediate'
      },
      {
        id: 8,
        front: '「志士仁人，無求生以害仁，有殺身以成仁」說明了什麼？',
        back: '說明仁者會為了成全仁德而犧牲自己。',
        category: '仁者精神',
        difficulty: 'advanced'
      },
      {
        id: 9,
        front: '仁與禮的關係是什麼？',
        back: '仁是內在的道德品質，禮是外在的行為規範，二者相輔相成。',
        category: '概念關係',
        difficulty: 'advanced'
      },
      {
        id: 10,
        front: '孔子仁學思想的現代意義是什麼？',
        back: '提倡愛人、和諧相處，對構建和諧社會有重要意義。',
        category: '現代意義',
        difficulty: 'advanced'
      },
      {
        id: 11,
        front: '「仁者愛人」的具體表現是什麼？',
        back: '關愛他人，推己及人，成人之美。',
        category: '愛人表現',
        difficulty: 'intermediate'
      },
      {
        id: 12,
        front: '語錄體與其他文體的區別是什麼？',
        back: '以對話形式記錄言論，體現思想精華，言簡意賅。',
        category: '文體比較',
        difficulty: 'intermediate'
      },
      {
        id: 13,
        front: '《論語》中的對比手法有什麼作用？',
        back: '通過對比突出仁者的品格特徵。',
        category: '表現手法',
        difficulty: 'intermediate'
      },
      {
        id: 14,
        front: '孔子仁學思想的核心價值是什麼？',
        back: '以人為本，強調人的道德修養和社會責任。',
        category: '核心價值',
        difficulty: 'advanced'
      },
      {
        id: 15,
        front: '學習《論語》論仁的意義是什麼？',
        back: '有助於提升個人品德修養，構建和諧的人際關係。',
        category: '學習意義',
        difficulty: 'advanced'
      }
    ]
  },

  // C1. 廉頗藺相如列傳
  {
    id: 'hkdse-flashcards-c1-sima-lianpo',
    textId: 'hkdse-c1-simaqian-lianpo-linxiangru',
    title: '《廉頗藺相如列傳》- 學習卡片',
    category: '人物傳記',
    description: '史傳文學和人物刻畫',
    totalCards: 25,
    cards: [
      {
        id: 1,
        front: '《廉頗藺相如列傳》包含哪三個主要故事？',
        back: '完璧歸趙、澠池之會、負荊請罪。',
        category: '故事結構',
        difficulty: 'beginner'
      },
      {
        id: 2,
        front: '「完璧歸趙」表現了藺相如的什麼品格？',
        back: '機智勇敢、忠心愛國、能言善辯。',
        category: '人物品格',
        difficulty: 'intermediate'
      },
      {
        id: 3,
        front: '「澠池之會」的意義是什麼？',
        back: '維護了趙國和趙王的尊嚴，展現了藺相如的愛國精神。',
        category: '故事意義',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '廉頗「負荊請罪」體現了什麼品格？',
        back: '勇於認錯、知錯能改、顧全大局。',
        category: '人物品格',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '司馬遷刻畫人物運用了哪些手法？',
        back: '語言描寫、動作描寫、神態描寫、側面描寫。',
        category: '刻畫手法',
        difficulty: 'intermediate'
      },
      {
        id: 6,
        front: '文中的對比手法體現在哪裡？',
        back: '藺相如與秦王的對比，廉頗與藺相如的對比。',
        category: '表現手法',
        difficulty: 'intermediate'
      },
      {
        id: 7,
        front: '「先國家之急而後私仇」體現了什麼精神？',
        back: '愛國主義精神和顧全大局的精神。',
        category: '精神品質',
        difficulty: 'intermediate'
      },
      {
        id: 8,
        front: '史傳文學的特點是什麼？',
        back: '具有真實性、文學性和教育性。',
        category: '文學特色',
        difficulty: 'intermediate'
      },
      {
        id: 9,
        front: '藺相如的「完璧歸趙」策略是什麼？',
        back: '以智取勝，威脅秦王，保全和氏璧。',
        category: '策略分析',
        difficulty: 'advanced'
      },
      {
        id: 10,
        front: '廉頗最初對藺相如的態度是什麼？',
        back: '不服氣，認為自己功勞更大。',
        category: '人物心理',
        difficulty: 'intermediate'
      },
      {
        id: 11,
        front: '藺相如為什麼要避讓廉頗？',
        back: '為了國家利益，避免內部分裂。',
        category: '行為動機',
        difficulty: 'intermediate'
      },
      {
        id: 12,
        front: '側面描寫的作用是什麼？',
        back: '通過他人的反應和評價來烘托主要人物的形象。',
        category: '描寫作用',
        difficulty: 'intermediate'
      },
      {
        id: 13,
        front: '三個故事的關係是什麼？',
        back: '遞進關係，逐步深化對人物品格的刻畫。',
        category: '結構關係',
        difficulty: 'advanced'
      },
      {
        id: 14,
        front: '秦王在故事中的作用是什麼？',
        back: '作為反面人物，襯托藺相如的高尚品格。',
        category: '人物作用',
        difficulty: 'intermediate'
      },
      {
        id: 15,
        front: '文中人物對話的特點是什麼？',
        back: '符合人物身份，推動情節發展，展現人物性格。',
        category: '對話特色',
        difficulty: 'intermediate'
      },
      {
        id: 16,
        front: '司馬遷寫作此文的目的是什麼？',
        back: '記錄歷史，歌頌英雄，教育後世。',
        category: '寫作目的',
        difficulty: 'intermediate'
      },
      {
        id: 17,
        front: '「怒髮衝冠」描寫的是什麼？',
        back: '描寫藺相如在澠池之會上的憤怒神態。',
        category: '神態描寫',
        difficulty: 'intermediate'
      },
      {
        id: 18,
        front: '廉頗的性格特點是什麼？',
        back: '直率、勇敢、知錯能改、愛國。',
        category: '性格分析',
        difficulty: 'intermediate'
      },
      {
        id: 19,
        front: '藺相如的性格特點是什麼？',
        back: '機智、勇敢、忠誠、寬容、顧全大局。',
        category: '性格分析',
        difficulty: 'intermediate'
      },
      {
        id: 20,
        front: '文章的主題思想是什麼？',
        back: '歌頌愛國主義精神，讚美高尚品格，提倡團結合作。',
        category: '主題思想',
        difficulty: 'advanced'
      },
      {
        id: 21,
        front: '史傳文學的教育意義是什麼？',
        back: '通過歷史人物的事蹟教育後人，傳承優秀品格。',
        category: '教育意義',
        difficulty: 'advanced'
      },
      {
        id: 22,
        front: '「負荊請罪」成為成語的原因是什麼？',
        back: '生動地表現了認錯改過的精神，具有典型意義。',
        category: '成語來源',
        difficulty: 'intermediate'
      },
      {
        id: 23,
        front: '文中的心理描寫體現在哪裡？',
        back: '通過人物的內心獨白和思想活動展現人物心理。',
        category: '心理描寫',
        difficulty: 'intermediate'
      },
      {
        id: 24,
        front: '這篇文章的現實意義是什麼？',
        back: '提倡愛國主義精神，強調團結合作的重要性。',
        category: '現實意義',
        difficulty: 'advanced'
      },
      {
        id: 25,
        front: '司馬遷的寫作技巧有什麼特點？',
        back: '善於刻畫人物，情節生動，語言簡潔有力。',
        category: '寫作技巧',
        difficulty: 'advanced'
      }
    ]
  },

  // D1. 岳陽樓記
  {
    id: 'hkdse-flashcards-d1-fan-yueyang',
    textId: 'hkdse-d1-fanzhongyan-yueyanglou-ji',
    title: '《岳陽樓記》- 學習卡片',
    category: '抒情遊記',
    description: '借景抒情和憂樂觀',
    totalCards: 20,
    cards: [
      {
        id: 1,
        front: '范仲淹寫作《岳陽樓記》的原因是什麼？',
        back: '應好友滕子京之請，為重修的岳陽樓作記。',
        category: '寫作背景',
        difficulty: 'beginner'
      },
      {
        id: 2,
        front: '「先天下之憂而憂，後天下之樂而樂」體現了什麼思想？',
        back: '憂國憂民、以天下為己任的崇高思想境界。',
        category: '思想境界',
        difficulty: 'intermediate'
      },
      {
        id: 3,
        front: '文中的「遷客騷人」指什麼人？',
        back: '被貶謫的官員和憂愁的文人。',
        category: '重要概念',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '文中運用了什麼主要的表現手法？',
        back: '借景抒情、託物言志、對比襯托。',
        category: '表現手法',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '「浩浩湯湯，橫無際涯」運用了什麼修辭？',
        back: '疊字修辭，增強了語言的音韻美。',
        category: '修辭手法',
        difficulty: 'intermediate'
      },
      {
        id: 6,
        front: '古代仁人的特點是什麼？',
        back: '不以物喜，不以己悲，先憂後樂。',
        category: '人物品格',
        difficulty: 'intermediate'
      },
      {
        id: 7,
        front: '文中描寫陰雨天氣的目的是什麼？',
        back: '烘托悲涼氣氛，與晴天美景形成對比。',
        category: '景物描寫',
        difficulty: 'intermediate'
      },
      {
        id: 8,
        front: '范仲淹的深層用意是什麼？',
        back: '勉勵同樣被貶的好友滕子京要有先憂後樂的胸懷。',
        category: '寫作用意',
        difficulty: 'advanced'
      },
      {
        id: 9,
        front: '文中的對比手法體現在哪些方面？',
        back: '陰雨與晴天、悲與喜、一般人與仁人的對比。',
        category: '對比手法',
        difficulty: 'intermediate'
      },
      {
        id: 10,
        front: '「微斯人，吾誰與歸」表達了什麼情感？',
        back: '表達了尋求知音、志同道合之人的情感。',
        category: '情感表達',
        difficulty: 'intermediate'
      },
      {
        id: 11,
        front: '文章的結構特點是什麼？',
        back: '記敘-描寫-議論-抒情，層層遞進。',
        category: '結構特點',
        difficulty: 'advanced'
      },
      {
        id: 12,
        front: '「不以物喜，不以己悲」的含義是什麼？',
        back: '不因外物的好壞而高興或悲傷，不因個人的得失而喜悅或憂愁。',
        category: '重要語句',
        difficulty: 'intermediate'
      },
      {
        id: 13,
        front: '洞庭湖的特點是什麼？',
        back: '浩瀚無邊，氣象萬千，景色變化多端。',
        category: '景物特點',
        difficulty: 'intermediate'
      },
      {
        id: 14,
        front: '文中的借景抒情體現在哪裡？',
        back: '通過描寫洞庭湖的不同景色來抒發不同的情感。',
        category: '抒情手法',
        difficulty: 'intermediate'
      },
      {
        id: 15,
        front: '范仲淹的憂樂觀是什麼？',
        back: '先天下之憂而憂，後天下之樂而樂的人生觀。',
        category: '人生觀',
        difficulty: 'intermediate'
      },
      {
        id: 16,
        front: '文中的託物言志體現在哪裡？',
        back: '託岳陽樓和洞庭湖之景，言憂國憂民之志。',
        category: '託物言志',
        difficulty: 'advanced'
      },
      {
        id: 17,
        front: '「居廟堂之高則憂其民，處江湖之遠則憂其君」說明了什麼？',
        back: '說明古代仁人無論在什麼位置都心繫國家和人民。',
        category: '仁人品格',
        difficulty: 'advanced'
      },
      {
        id: 18,
        front: '文章的現實意義是什麼？',
        back: '提倡憂國憂民精神，樹立正確的人生觀。',
        category: '現實意義',
        difficulty: 'advanced'
      },
      {
        id: 19,
        front: '遊記文體的特點是什麼？',
        back: '記遊山水，借景抒情，表達情懷。',
        category: '文體特色',
        difficulty: 'intermediate'
      },
      {
        id: 20,
        front: '《岳陽樓記》的藝術成就是什麼？',
        back: '情景交融，議論精闢，語言優美，思想深刻。',
        category: '藝術成就',
        difficulty: 'advanced'
      }
    ]
  },

  // F1. 唐詩三首
  {
    id: 'hkdse-flashcards-f1-tang-poems',
    textId: 'hkdse-f1-tangshi-sanzhou',
    title: '唐詩三首 - 學習卡片',
    category: '詩詞',
    description: '唐詩藝術特色和情感表達',
    totalCards: 22,
    cards: [
      {
        id: 1,
        front: '王維《山居秋暝》表達了什麼情感？',
        back: '對隱居生活的嚮往和對自然美景的讚美。',
        category: '情感表達',
        difficulty: 'intermediate'
      },
      {
        id: 2,
        front: '李白《月下獨酌》的主要情感是什麼？',
        back: '孤單落寞、鬱悶不快、缺少知己的情感。',
        category: '情感表達',
        difficulty: 'intermediate'
      },
      {
        id: 3,
        front: '杜甫《登樓》體現了什麼思想感情？',
        back: '憂國憂民、懷才不遇的無奈和愛國情懷。',
        category: '思想感情',
        difficulty: 'intermediate'
      },
      {
        id: 4,
        front: '王維詩歌的藝術特色是什麼？',
        back: '詩中有畫，意境深遠，清新自然。',
        category: '藝術特色',
        difficulty: 'intermediate'
      },
      {
        id: 5,
        front: '李白詩歌的風格特點是什麼？',
        back: '豪邁奔放，想象豐富，情感真摯。',
        category: '風格特點',
        difficulty: 'intermediate'
      },
      {
        id: 6,
        front: '杜甫詩歌的特色是什麼？',
        back: '沉鬱頓挫，憂國憂民，現實主義。',
        category: '詩歌特色',
        difficulty: 'intermediate'
      },
      {
        id: 7,
        front: '「明月松間照，清泉石上流」運用了什麼手法？',
        back: '動靜結合，視聽結合，色彩搭配。',
        category: '表現手法',
        difficulty: 'intermediate'
      },
      {
        id: 8,
        front: '「舉杯邀明月，對影成三人」體現了什麼？',
        back: '想象奇特，情感孤獨，浪漫情懷。',
        category: '想象技巧',
        difficulty: 'intermediate'
      },
      {
        id: 9,
        front: '「花近高樓傷客心」中的「傷」字有什麼作用？',
        back: '點明情感基調，突出內心痛苦。',
        category: '煉字藝術',
        difficulty: 'intermediate'
      },
      {
        id: 10,
        front: '唐詩的體例特點是什麼？',
        back: '格律嚴謹，平仄協調，對仗工整。',
        category: '體例特點',
        difficulty: 'intermediate'
      },
      {
        id: 11,
        front: '王維的「詩中有畫」體現在哪裡？',
        back: '通過色彩、光影、動靜的描寫營造畫面感。',
        category: '藝術手法',
        difficulty: 'advanced'
      },
      {
        id: 12,
        front: '李白的浪漫主義特色體現在哪裡？',
        back: '豐富的想象、奇特的比喻、誇張的手法。',
        category: '浪漫主義',
        difficulty: 'advanced'
      },
      {
        id: 13,
        front: '杜甫的現實主義特色體現在哪裡？',
        back: '關注現實，反映社會問題，情感真摯。',
        category: '現實主義',
        difficulty: 'advanced'
      },
      {
        id: 14,
        front: '唐詩中的借景抒情有什麼作用？',
        back: '使情感更加真切，增強藝術感染力。',
        category: '抒情手法',
        difficulty: 'intermediate'
      },
      {
        id: 15,
        front: '三位詩人的共同特點是什麼？',
        back: '都有高超的藝術技巧和深厚的文學造詣。',
        category: '共同特點',
        difficulty: 'intermediate'
      },
      {
        id: 16,
        front: '「空山新雨後」的「空」字妙在哪裡？',
        back: '既寫出山的空靈，又突出了環境的幽靜。',
        category: '煉字藝術',
        difficulty: 'advanced'
      },
      {
        id: 17,
        front: '「萬里悲秋常作客」表達了什麼情感？',
        back: '表達了漂泊異鄉、年老多病的悲涼情感。',
        category: '情感分析',
        difficulty: 'intermediate'
      },
      {
        id: 18,
        front: '唐詩的意境營造主要通過什麼實現？',
        back: '景物描寫、情感抒發、想象聯想。',
        category: '意境營造',
        difficulty: 'intermediate'
      },
      {
        id: 19,
        front: '「竹喧歸浣女，蓮動下漁舟」運用了什麼手法？',
        back: '以動寫靜，以聲襯靜，生動自然。',
        category: '表現技巧',
        difficulty: 'advanced'
      },
      {
        id: 20,
        front: '學習唐詩的意義是什麼？',
        back: '提高文學素養，陶冶情操，傳承文化。',
        category: '學習意義',
        difficulty: 'intermediate'
      },
      {
        id: 21,
        front: '唐詩的語言特色是什麼？',
        back: '精煉優美，音韻和諧，富有表現力。',
        category: '語言特色',
        difficulty: 'intermediate'
      },
      {
        id: 22,
        front: '唐詩對後世文學的影響是什麼？',
        back: '樹立了詩歌典範，影響了創作風格，豐富了表達技巧。',
        category: '歷史影響',
        difficulty: 'advanced'
      }
    ]
  }
];

// 學習卡片統計數據
export const hkdseFlashCardsStats = {
  totalSets: hkdseFlashCards.length,
  totalCards: hkdseFlashCards.reduce((sum, set) => sum + set.totalCards, 0),
  categoryDistribution: hkdseFlashCards.reduce((acc, set) => {
    acc[set.category] = (acc[set.category] || 0) + 1;
    return acc;
  }, {}),
  difficultyDistribution: hkdseFlashCards.reduce((acc, set) => {
    set.cards.forEach(card => {
      acc[card.difficulty] = (acc[card.difficulty] || 0) + 1;
    });
    return acc;
  }, {})
};

// 根據文本ID獲取學習卡片
export const getHKDSEFlashCardsByTextId = (textId) => {
  return hkdseFlashCards.find(set => set.textId === textId);
};

// 根據類別獲取學習卡片
export const getHKDSEFlashCardsByCategory = (category) => {
  return hkdseFlashCards.filter(set => set.category === category);
};

// 根據難度獲取學習卡片
export const getHKDSEFlashCardsByDifficulty = (difficulty) => {
  return hkdseFlashCards.filter(set => 
    set.cards.some(card => card.difficulty === difficulty)
  );
};

// 隨機打亂卡片順序
export const shuffleFlashCards = (cards) => {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// 根據類別分組卡片
export const groupFlashCardsByCategory = (cards) => {
  return cards.reduce((acc, card) => {
    const category = card.category || '其他';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(card);
    return acc;
  }, {});
}; 